webpackJsonp([38],{

/***/ "0Oh6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  path: "/consult/add",
  component: function component() {
    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, "h7am"));
  }
}];

/***/ }),

/***/ "2tPc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  path: "/audio/index",
  component: function component() {
    return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "as1c"));
  }
}];

/***/ }),

/***/ "5reh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var USER_REG_FORM = exports.USER_REG_FORM = "USER_REG_FORM";
var INDEX_DATA_KNOWLAGE = exports.INDEX_DATA_KNOWLAGE = "INDEX_DATA_KNOWLAGE";
var CURRENT_AUDIO_URL = exports.CURRENT_AUDIO_URL = 'CURRENT_AUDIO_URL';

/***/ }),

/***/ "6nUf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  path: "/health",
  component: function component() {
    return __webpack_require__.e/* import() */(23).then(__webpack_require__.bind(null, "qCJ8"));
  }
}, {
  path: "/health/news",
  component: function component() {
    return __webpack_require__.e/* import() */(19).then(__webpack_require__.bind(null, "Cjk8"));
  }
}];

/***/ }),

/***/ "6xQD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  path: "/doc/:id",
  component: function component() {
    return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, "jCiD"));
  }
}, {
  path: "/doc/article/:id",
  component: function component() {
    return __webpack_require__.e/* import() */(13).then(__webpack_require__.bind(null, "F9Cf"));
  }
}, {
  path: "/doc/audio/:id",
  component: function component() {
    return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "gvJv"));
  }
}];

/***/ }),

/***/ "CPGk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeRandom = makeRandom;
exports.arrayFind = arrayFind;
exports.getConsultStatusText = getConsultStatusText;
exports.getBookOrderStatusText = getBookOrderStatusText;
exports.isBrower = isBrower;
exports.passFormat = passFormat;
exports.debug = debug;
exports.makeUrl = makeUrl;
exports.getParamsFromUrl = getParamsFromUrl;

var _config = __webpack_require__("rvz5");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * 生成指定长度随机数
 * @param length
 * @returns {string}
 */
function makeRandom(length) {
  var str = "0123456789",
      ret = "";
  for (var i = 0; i < length; i++) {
    ret += str.substr(Math.floor(Math.random() * str.length), 1);
  }
  return ret;
}

/**
 * 根据条件返回数组指定元素
 * @param array
 * @param fn
 * @returns {null}
 */
function arrayFind(array, fn) {
  var index = array.findIndex(fn);
  return index > -1 ? array[index] : null;
}

/**
 * 获得咨询状态
 * @param status
 * @returns {string}
 */
function getConsultStatusText(status) {
  var c = arrayFind(_config2.default.consult_status, function (res) {
    return res.status == status;
  });
  return c ? c.name : "暂无";
}

/**
 * 获得订单状态
 * @param status
 */
function getBookOrderStatusText(status) {
  return arrayFind(_config2.default.book_order_status, function (res) {
    return res.status == status;
  }).name;
}

/**
 * 判断浏览器类型
 * @param name
 * iphone
 * android
 * micromessenger
 * @returns {boolean}
 */
function isBrower(name) {
  var UA = window.navigator.userAgent.toLowerCase();
  return UA.indexOf(name) > -1;
}

/**
 * 密码加密处理
 * @param pass
 * @returns {*}
 */
function passFormat(pass) {
  return sha512(hex_md5(pass) + pass);
}

/**
 * @param args
 */
function debug() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  console.log.apply(console, args);
}

/**
 * 生成返回URL
 * @param options
 * @returns {string}
 */
function makeUrl(options) {
  var url = "";
  if (options.protocol) {
    url += options.protocol + "://";
  }
  if (options.hostname) {
    url += options.hostname;
  }
  if (options.port && options.port != 80 && options.port != 443) {
    url += ":" + options.port;
  }
  if (options.path) {
    url += options.path;
  }
  if (options.query) {
    var q = "";
    for (var key in options.query) {
      if (options.query[key]) {
        q += "&" + key + "=" + options.query[key];
      } else {
        q += "&" + key;
      }
    }
    q = q.substr(1);
    url += "?" + q;
  }
  if (options.hash) {
    url += "#" + options.hash;
  }
  return url;
}

/**
 * 解析url参数
 * @param from
 * @returns {{protocol: *, hostname: *, port: *, path: *, query: *, hash: *}}
 */
function getParamsFromUrl(from) {
  var protocol = url("protocol", from);
  var hostname = url("hostname", from);
  var port = url("port", from);
  var path = url("path", from);
  var query = url("?", from);
  var hash = url("hash", from);
  return { protocol: protocol, hostname: hostname, port: port, path: path, query: query, hash: hash };
}

/***/ }),

/***/ "HMjS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    path: "/my",
    component: function component() {
        return __webpack_require__.e/* import() */(22).then(__webpack_require__.bind(null, "ULSo"));
    },
    meta: {
        needLogin: true
    }
}, {
    path: "/my/archives",
    component: function component() {
        return __webpack_require__.e/* import() */(25).then(__webpack_require__.bind(null, "tqty"));
    }
}, {
    path: "/my/archives/save-record/:type",
    component: function component() {
        return __webpack_require__.e/* import() */(21).then(__webpack_require__.bind(null, "zFwP"));
    }
}, {
    path: "/my/common-visitperson",
    component: function component() {
        return __webpack_require__.e/* import() */(27).then(__webpack_require__.bind(null, "F2ee"));
    }
}, {
    path: "/my/my-consult",
    component: function component() {
        return __webpack_require__.e/* import() */(6).then(__webpack_require__.bind(null, "bvtw"));
    }
}, {
    path: "/my/my-book",
    component: function component() {
        return __webpack_require__.e/* import() */(28).then(__webpack_require__.bind(null, "4SrS"));
    }
}, {
    path: "/my/wallet",
    component: function component() {
        return __webpack_require__.e/* import() */(26).then(__webpack_require__.bind(null, "zb22"));
    }
}, {
    path: "/my/account",
    component: function component() {
        return __webpack_require__.e/* import() */(30).then(__webpack_require__.bind(null, "OYgv"));
    }
}, {
    path: "/my/about",
    component: function component() {
        return __webpack_require__.e/* import() */(20).then(__webpack_require__.bind(null, "DO0k"));
    }
}];

/***/ }),

/***/ "IcnI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _state = __webpack_require__("lwq5");

var _state2 = _interopRequireDefault(_state);

var _actions = __webpack_require__("mUbh");

var _actions2 = _interopRequireDefault(_actions);

var _mutations = __webpack_require__("ukYY");

var _mutations2 = _interopRequireDefault(_mutations);

var _getters = __webpack_require__("UjVw");

var _getters2 = _interopRequireDefault(_getters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: _state2.default,
  mutations: _mutations2.default,
  actions: _actions2.default,
  getters: _getters2.default
});

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("sEFh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__) if(["default","default"].indexOf(__WEBPACK_IMPORT_KEY__) < 0) (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_70f23069_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("bQry");
function injectStyle (ssrContext) {
  __webpack_require__("h68h")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_13_7_3_vue_loader_lib_template_compiler_index_id_data_v_70f23069_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_13_7_3_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _assign = __webpack_require__("woOf");

var _assign2 = _interopRequireDefault(_assign);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _router = __webpack_require__("YaEn");

var _router2 = _interopRequireDefault(_router);

var _index = __webpack_require__("IcnI");

var _index2 = _interopRequireDefault(_index);

var _util = __webpack_require__("CPGk");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.config.productionTip = false; // The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.


var query = url("?", location.href),
    options = (0, _util.getParamsFromUrl)(location.href);
if (query && query.version) {
  init();
} else {
  query = (0, _assign2.default)({}, query, { versin: window.version });
  location.replace((0, _util.makeUrl)((0, _assign2.default)({}, options, { query: query })));
}

//oauth2(init);
init();

function init() {
  /* eslint-disable no-new */
  new _vue2.default({
    el: '#app',
    router: _router2.default,
    store: _index2.default,
    template: '<App/>',
    components: { App: _App2.default }
  });
}

/***/ }),

/***/ "RoNQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    path: "/my-doc",
    component: function component() {
        return __webpack_require__.e/* import() */(14).then(__webpack_require__.bind(null, "S425"));
    }
}, {
    path: "/follow-doc",
    component: function component() {
        return __webpack_require__.e/* import() */(18).then(__webpack_require__.bind(null, "j1qs"));
    }
}, {
    path: "/chart",
    component: function component() {
        return __webpack_require__.e/* import() */(24).then(__webpack_require__.bind(null, "ZUfC"));
    }
}];

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _types$USER_REG_FORM$;

var _types = __webpack_require__("5reh");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_types$USER_REG_FORM$ = {}, (0, _defineProperty3.default)(_types$USER_REG_FORM$, types.USER_REG_FORM, function (state) {
  return state[types.USER_REG_FORM];
}), (0, _defineProperty3.default)(_types$USER_REG_FORM$, types.INDEX_DATA_KNOWLAGE, function (state) {
  return state[types.INDEX_DATA_KNOWLAGE];
}), _types$USER_REG_FORM$);

/***/ }),

/***/ "WwcQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.openidCache = exports.fromCache = exports.userCache = exports.tokenCache = exports.historyCache = undefined;

var _getPrototypeOf = __webpack_require__("Zx67");

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _possibleConstructorReturn2 = __webpack_require__("zwoO");

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__("Pf15");

var _inherits3 = _interopRequireDefault(_inherits2);

var _classCallCheck2 = __webpack_require__("Zrlr");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__("wxAW");

var _createClass3 = _interopRequireDefault(_createClass2);

var _goodStorage = __webpack_require__("bFR2");

var _goodStorage2 = _interopRequireDefault(_goodStorage);

var _config = __webpack_require__("rvz5");

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var cache = function () {
  function cache(key, session) {
    (0, _classCallCheck3.default)(this, cache);

    this.key = key;
    this.session = session ? true : false;
  }

  (0, _createClass3.default)(cache, [{
    key: "get",
    value: function get() {
      if (this.session) {
        return _goodStorage2.default.session.get(this.key, null);
      } else {
        return _goodStorage2.default.get(this.key, null);
      }
    }
  }, {
    key: "set",
    value: function set(value) {
      if (this.session) {
        _goodStorage2.default.session.set(this.key, value);
      } else {
        _goodStorage2.default.set(this.key, value);
      }
    }
  }, {
    key: "remove",
    value: function remove() {
      if (this.session) {
        _goodStorage2.default.session.remove(this.key);
      } else {
        _goodStorage2.default.remove(this.key);
      }
    }
  }]);
  return cache;
}();

var prefix = _config2.default.key_prefix + (window.version || "") + "_";

var HISTORY_CACHE_KEY = prefix + "history_";

var history = function (_cache) {
  (0, _inherits3.default)(history, _cache);

  function history(key, session) {
    (0, _classCallCheck3.default)(this, history);
    return (0, _possibleConstructorReturn3.default)(this, (history.__proto__ || (0, _getPrototypeOf2.default)(history)).call(this, key, session));
  }

  (0, _createClass3.default)(history, [{
    key: "get",
    value: function get() {
      if (this.session) {
        return _goodStorage2.default.session.get(this.key, []);
      } else {
        return _goodStorage2.default.get(this.key, []);
      }
    }
  }, {
    key: "inHistory",
    value: function inHistory(path) {
      var arr = this.get();
      return arr.findIndex(function (history) {
        return history == path;
      });
    }
  }, {
    key: "clear",
    value: function clear() {
      if (this.session) {
        _goodStorage2.default.session.remove(this.key);
      } else {
        _goodStorage2.default.remove(this.key);
      }
    }
  }]);
  return history;
}(cache);

var historyCache = exports.historyCache = new history(HISTORY_CACHE_KEY, true);

var TOKEN_CACHE_KEY = prefix + "token_";
var tokenCache = exports.tokenCache = new cache(TOKEN_CACHE_KEY);

var USER_CACHE_KEY = prefix + "user_";
var userCache = exports.userCache = new cache(USER_CACHE_KEY);

var FROM_CACHE_KEY = prefix + "from_";
var fromCache = exports.fromCache = new cache(FROM_CACHE_KEY, true);

var OPENID_CACHE_KEY = prefix + "openid_";
var openidCache = exports.openidCache = new cache(OPENID_CACHE_KEY);

/***/ }),

/***/ "YaEn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _toConsumableArray2 = __webpack_require__("Gu7T");

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _cache = __webpack_require__("WwcQ");

var _myDoc = __webpack_require__("RoNQ");

var _myDoc2 = _interopRequireDefault(_myDoc);

var _health = __webpack_require__("6nUf");

var _health2 = _interopRequireDefault(_health);

var _my = __webpack_require__("HMjS");

var _my2 = _interopRequireDefault(_my);

var _home = __webpack_require__("roEk");

var _home2 = _interopRequireDefault(_home);

var _user = __webpack_require__("jnTS");

var _user2 = _interopRequireDefault(_user);

var _indexChildren = __webpack_require__("pEzy");

var _indexChildren2 = _interopRequireDefault(_indexChildren);

var _consult = __webpack_require__("0Oh6");

var _consult2 = _interopRequireDefault(_consult);

var _doc = __webpack_require__("6xQD");

var _doc2 = _interopRequireDefault(_doc);

var _news = __webpack_require__("pEPG");

var _news2 = _interopRequireDefault(_news);

var _Audio = __webpack_require__("2tPc");

var _Audio2 = _interopRequireDefault(_Audio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vueRouter2.default);

var router = new _vueRouter2.default({
  routes: [{
    path: '/',
    component: function component() {
      return __webpack_require__.e/* import() */(15).then(__webpack_require__.bind(null, "2NXm"));
    },
    children: [].concat((0, _toConsumableArray3.default)(_indexChildren2.default))
  }, {
    path: '/audios',
    component: function component() {
      return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, "Sjri"));
    }
  }, {
    path: '/download',
    component: function component() {
      return __webpack_require__.e/* import() */(12).then(__webpack_require__.bind(null, "5dr8"));
    }
  }, {
    path: '/download/doc',
    component: function component() {
      return __webpack_require__.e/* import() */(34).then(__webpack_require__.bind(null, "P+RA"));
    }
  }, {
    path: '/active',
    component: function component() {
      return __webpack_require__.e/* import() */(17).then(__webpack_require__.bind(null, "aKA3"));
    }
  }].concat((0, _toConsumableArray3.default)(_doc2.default), (0, _toConsumableArray3.default)(_consult2.default), (0, _toConsumableArray3.default)(_myDoc2.default), (0, _toConsumableArray3.default)(_health2.default), (0, _toConsumableArray3.default)(_my2.default), (0, _toConsumableArray3.default)(_home2.default), (0, _toConsumableArray3.default)(_user2.default), (0, _toConsumableArray3.default)(_news2.default), (0, _toConsumableArray3.default)(_Audio2.default))

});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.needLogin;
  })) {
    var token = _cache.tokenCache.get();
    if (token) {
      next();
    } else {
      _cache.fromCache.set(to.fullPath);
      next('/login');
    }
  } else {
    next();
  }
});

/*路由懒加载*/
exports.default = router;

/***/ }),

/***/ "bQry":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":_vm.page}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "h68h":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jnTS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  path: "/login",
  component: function component() {
    return __webpack_require__.e/* import() */(11).then(__webpack_require__.bind(null, "rqbd"));
  }
}, {
  path: "/reg",
  component: function component() {
    return __webpack_require__.e/* import() */(10).then(__webpack_require__.bind(null, "SZsY"));
  },
  children: [{
    path: 'step1',
    name: 'step1',
    component: function component() {
      return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "OTSc"));
    }
  }, {
    path: 'step2',
    name: 'step2',
    component: function component() {
      return __webpack_require__.e/* import() */(36).then(__webpack_require__.bind(null, "Zeuf"));
    }
  }]
}, {
  path: "/reset",
  component: function component() {
    return __webpack_require__.e/* import() */(9).then(__webpack_require__.bind(null, "tGgt"));
  },
  children: [{
    path: 'step1',
    name: 'step1',
    component: function component() {
      return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, "OTSc"));
    }
  }, {
    path: 'step2',
    name: 'step2',
    component: function component() {
      return __webpack_require__.e/* import() */(35).then(__webpack_require__.bind(null, "Di28"));
    }
  }]
}];

/***/ }),

/***/ "lwq5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _types$USER_REG_FORM$;

var _types = __webpack_require__("5reh");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_types$USER_REG_FORM$ = {}, (0, _defineProperty3.default)(_types$USER_REG_FORM$, types.USER_REG_FORM, {}), (0, _defineProperty3.default)(_types$USER_REG_FORM$, types.INDEX_DATA_KNOWLAGE, []), (0, _defineProperty3.default)(_types$USER_REG_FORM$, types.CURRENT_AUDIO_URL, ''), _types$USER_REG_FORM$);

/***/ }),

/***/ "mUbh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _types = __webpack_require__("5reh");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

exports.default = {};

/***/ }),

/***/ "pEPG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  path: "/news/:id",
  component: function component() {
    return __webpack_require__.e/* import() */(16).then(__webpack_require__.bind(null, "MonK"));
  }
}];

/***/ }),

/***/ "pEzy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = [{
    path: "",
    component: function component() {
        return __webpack_require__.e/* import() */(8).then(__webpack_require__.bind(null, "fNtn"));
    }
}, {
    path: "ask-doc",
    component: function component() {
        return __webpack_require__.e/* import() */(7).then(__webpack_require__.bind(null, "CmK4"));
    },
    meta: {
        needLogin: true
    }
}, {
    path: "more",
    component: function component() {
        return __webpack_require__.e/* import() */(31).then(__webpack_require__.bind(null, "Ahwf"));
    }
}];

/***/ }),

/***/ "roEk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = [{
  path: "/home/server/book",
  component: function component() {
    return __webpack_require__.e/* import() */(32).then(__webpack_require__.bind(null, "TqRz"));
  }
}, {
  path: "/home/server/book/dept",
  component: function component() {
    return __webpack_require__.e/* import() */(29).then(__webpack_require__.bind(null, "jpnp"));
  }
}, {
  path: "/home/server/book/doc",
  component: function component() {
    return __webpack_require__.e/* import() */(33).then(__webpack_require__.bind(null, "evEj"));
  }
}];

/***/ }),

/***/ "rvz5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  key_prefix: "mingshi_pat_",
  api_url: appConfig.api_url,
  base_params: {
    channel: "23",
    format: "JSON",
    oper: "127.0.0.1",
    random: "1234",
    sign: "3f52f63fad63c5dd209d28420977fb5d",
    spid: "1001"
  },
  nav: [{ name: "home", value: "首页" }, { name: "my-doc", value: "我的医生" }, { name: "health", value: "健康" }, { name: "my", value: "我的" }],
  index_fast_nav: [{ name: "fast-consult", value: "快速咨询", text: "名医知道", path: "/" }, { name: "fast-consult", value: "快速咨询", text: "问医生", path: "/ask-doc" }, { name: "ask-doc", value: "问医生", text: "更多功能", path: "/more" }],
  index_nav: [{ name: "guide", value: "我的医生" }, { name: "book", value: "预约挂号" }, { name: "queuing", value: "就诊加号" }, { name: "payment", value: "眼底病优先通道" }, { name: "report", value: "眼外伤快速预约" }, { name: "more", value: "更多" }],
  my_doc_nav: [{ name: "follow", value: "关注医生", path: "/follow-doc" }, { name: "circle", value: "医生圈", path: "doc-circle" }],
  health_nav: [{ name: "archives", value: "健康档案" }, { name: "wiki", value: "健康百科" }],
  my_nav: [{ name: "my-consult", value: "我的咨询", path: "/my-consult" }, { name: "my-book", value: "我的挂号", path: "/my-book" }, { name: "common-visitperson", value: "常用就诊人", path: "/common-visitperson" }, { name: "archives", value: "健康档案", path: "/archives" }, { name: "wallet", value: "我的钱包", path: "/wallet" }, {
    name: "account", value: "账户相关", path: "/account", child: [{ name: "", value: "修改绑定手机号" }, { name: "", value: "修改密码" }]
  }, { name: "about", value: "关于", path: "/about" }],
  doc_nav: [{ name: "book", value: "预约挂号" }, { name: "apply", value: "加号申请" }, { name: "baodao", value: "患者报到" }],
  book_doc_nav: [{ name: "bypeople", value: "按专家预约" }, { name: "bytime", value: "按时间预约" }],
  basic_situation: [{ name: "", value: "所患疾病" }, { name: "", value: "既往史" }, { name: "", value: "家族史" }, { name: "", value: "过敏史" }],
  consult_type_nav: [{ name: "", value: "全部问诊" }, { name: "", value: "全部状态" }],
  consult_status: [{ name: "待付款", status: "0" }, { name: "待处理", status: "2" }, { name: "进行中", status: "3" }, { name: "待评价", status: "5" }, { name: "已评价", status: "7" }, { name: "已取消", status: "-1" }],
  book_order_status: [{ name: "已取消", status: "0" }, { name: "待取号", status: "1" }, { name: "待评价", status: "2" }, { name: "已评价", status: "3" }, { name: "已过期", status: "4" }],
  help: [{ name: "全科分诊", class: "qkfz" }, { name: "名医视频", class: "mysp" }, { name: "在线医生", class: "zxys" }, { name: "预约挂号", class: "yygh" }, { name: "常用就诊人", class: "cyjzr" }, { name: "健康档案", class: "jkda" }, { name: "消费明细", class: "xfmx" }, { name: "修改绑定手机号", class: "xgbdsjh" }, { name: "修改密码", class: "xgmm" }]
};

/***/ }),

/***/ "sEFh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _cache = __webpack_require__("WwcQ");

exports.default = {
  name: 'app',
  data: function data() {
    return {
      page: ""
    };
  },
  created: function created() {},


  watch: {
    $route: function $route(to, from) {
      var p = to.fullPath;
      if (p === from.fullPath || new Date().getTime() - window.appStartTime < 200) {
        _cache.historyCache.clear();
        _cache.historyCache.set([p]);
        return;
      }
      var history = _cache.historyCache.get();
      var index = _cache.historyCache.inHistory(p);
      if (index > -1) {
        this.page = "right";
        history.splice(index + 1);
      } else {
        this.page = "left";
        history.push(p);
      }
      _cache.historyCache.set(history);
    }
  }
}; //
//
//
//
//
//
//
//

/***/ }),

/***/ "ukYY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__("bOdI");

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _types$USER_REG_FORM$;

var _types = __webpack_require__("5reh");

var types = _interopRequireWildcard(_types);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (_types$USER_REG_FORM$ = {}, (0, _defineProperty3.default)(_types$USER_REG_FORM$, types.USER_REG_FORM, function (state, payload) {
  state[types.USER_REG_FORM] = payload;
}), (0, _defineProperty3.default)(_types$USER_REG_FORM$, types.INDEX_DATA_KNOWLAGE, function (state, payload) {
  state[types.INDEX_DATA_KNOWLAGE] = payload;
}), (0, _defineProperty3.default)(_types$USER_REG_FORM$, types.CURRENT_AUDIO_URL, function (state, paylod) {
  state[types.CURRENT_AUDIO_URL] = paylod;
}), _types$USER_REG_FORM$);

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.21353a310b75a14dab1c.js